export async function runGuestXMFunctions(data) {
    let returnData = '';
    const formData = new FormData();

    for (const [key, value] of Object.entries(data)) {
        if (Array.isArray(value)) {
            value.forEach(item => formData.append(key + '[]', item));
        } else {
            formData.append(key, value);
        }
    }

    try {
        const response = await fetch(igniteAjax.ajaxurl, {
            method: 'POST',
            body: formData
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        returnData = await response.json();
    } catch (error) {
        console.error('Error:', error);
        returnData = {
            error: true,
            heading: 'An Error Has Occurred',
            content: 'Sorry, we couldn\'t submit your enquiry right now. Please try again later.'
        };
    }

    return returnData;
}
